import React from 'react';
import PropTypes from 'prop-types';
import type { HelpIconProps } from './types';

export class HelpIcon extends React.PureComponent<HelpIconProps> {
  element: React.RefObject<HTMLAnchorElement>;

  constructor(props: HelpIconProps) {
    super(props);
    this.element = React.createRef();
  }

  onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation();
    event.preventDefault();
    // eslint-disable-next-line no-undef
    PopupController.PopupJsClick!(this.element.current);
  };

  render() {
    const { topic, ariaLabel, disabled } = this.props;
    return (
      // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid
      <a
        ref={this.element}
        className="helpbutton"
        tabIndex={0}
        topic={topic.trim()}
        type="helppopup"
        onClick={this.onClick}
        // eslint-disable-next-line no-script-url
        href="#"
        aria-label={ariaLabel}
        disabled={disabled}
      />
    );
  }
}

(HelpIcon as typeof HelpIcon & { propTypes: Record<string, unknown> }).propTypes = {
  topic: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

(HelpIcon as typeof HelpIcon & { defaultProps: Partial<HelpIconProps> }).defaultProps = {
  ariaLabel: 'Learn more',
  disabled: false,
};
